import React, { useContext } from 'react';
import classNames from 'classnames/bind';
import { InputFile } from 'gd-design-library';
import VisualSearchIcon from '@assets/images/visual-search.svg';
import styles from './ImageUploadButton.module.scss';
import { SnackbarContext } from '@utils';
import { ACCEPTED_IMAGE_TYPES, MAX_FILE_SIZE_MB } from 'components/SmartSearch/constants/imageUpload';
import Image from 'next/image';

const cx = classNames.bind(styles);
const CN = 'image-upload-button';

interface ImageUploadButtonProps {
  setUploadedImage: React.Dispatch<React.SetStateAction<File | null>>;
  disabled?: boolean;
}

export const ImageUploadButton: React.FC<ImageUploadButtonProps> = ({
  setUploadedImage,
  disabled = false
}) => {
  const { setSnackbarParams } = useContext(SnackbarContext);

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
    const file = event.target.files?.[0];
    if (!file) {
      event.target.value = '';

      return;
    }

    if (file.size > MAX_FILE_SIZE_MB * 1024 * 1024) {
      setSnackbarParams({
        message: `Selected file is too large (max ${MAX_FILE_SIZE_MB}MB).`,
        severity: 'warning',
        open: true,
        onClose: () => setSnackbarParams({ open: false, message: '', onClose: () => null })
      });
      event.target.value = '';

      return;
    }

    setUploadedImage(file);
    event.target.value = '';
  };

  return (
    <InputFile
      accept={ ACCEPTED_IMAGE_TYPES }
      multiple={ false }
      onChange={ handleFileChange }
      disabled={ disabled }
      style={ { overflow: 'visible' } }
      buttonProps={ {
        variant: 'text',
        className: cx(CN),
        'aria-label': 'Upload reference image'
      } }
    >
      <Image
        src={ VisualSearchIcon.src }
        alt='Filter Center Focus'
        width={ 24 }
        height={ 24 }
        style={ { opacity: disabled ? 0.5 : 1 } }
      />
    </InputFile>
  );
};
